//
// Functions helpers to filter by URL
//
export const getParamsOrDeleteString = (params, key) => {
    return params.get(key) ? params.get(key) : params.delete(key);
};

export const getParamsOrDeleteDate = (params, key) => {
    return params.get(key) ? new Date(params.get(key)) : params.delete(key);
};

export const getParamsOrDeleteNumber = (params, key) => {
    return params.get(key) ? Number(params.get(key)) : params.delete(key);
};

export const setOrDeleteParams = (params, key, value) => {
    value ? params.set(key, value) : params.delete(key);
};

/**
 *
 * @param {*} params Is an instance of new URLSearchParams
 * @param {*} searchText They are the criteria that you want
 * @param {*} allSearchText Are all possible search criteria
 * @returns An instance of URLSearchParams with the searched criteria
 */
export const getObjectUrl = (params, searchText, allSearchText) => {
    const oldQueryParams = {};
    // Display the values
    // const obj = {};
    // for (var value of params.keys()) {
    //     obj[value] = params.get(value);
    // }
    oldQueryParams.sortOrder = getParamsOrDeleteString(params, 'sortOrder');
    oldQueryParams.sortField = getParamsOrDeleteString(params, 'sortField');
    oldQueryParams.pageNumber = getParamsOrDeleteNumber(params, 'pageNumber');
    oldQueryParams.pageSize = getParamsOrDeleteNumber(params, 'pageSize');

    oldQueryParams.dateFrom = getParamsOrDeleteDate(params, 'dateFrom');
    oldQueryParams.dateTo = getParamsOrDeleteDate(params, 'dateTo');

    for (const key in allSearchText) {
        if (Object.hasOwnProperty.call(searchText, key)) {
            oldQueryParams[key] = getParamsOrDeleteString(params, key);
        }
    }

    return oldQueryParams;
};
